import { Check } from "lucide-react";
import { IntakeForm } from "../IntakeForm";
import { Reveal, SectionHeading } from "../Reveal";

const BULLETS = [
  "A free 30-minute strategy call with a senior consultant",
  "A written summary of your options within 24 hours",
  "Zero obligation, zero pressure — clarity either way",
];

export function LeadCapture() {
  return (
    <section id="lead-capture" data-testid="lead-capture-section" className="bg-bone py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <SectionHeading
              chapter={["06", "Your Next Step"]}
              title={
                <>
                  Get clarity in{" "}
                  <em className="font-editorial font-medium italic text-gold-dark">your next step.</em>
                </>
              }
              subtitle="Answer four quick questions and we'll match you with the right consultant. Your future self will thank you for this minute."
            />
            <ul className="mt-9 space-y-4" data-testid="lead-capture-benefits">
              {BULLETS.map((b, i) => (
                <Reveal key={b} delay={0.1 + i * 0.08}>
                  <li className="flex items-start gap-3.5">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest text-bone">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm leading-relaxed text-foreground/80 sm:text-base">{b}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.35}>
              <div className="mt-10 border-l-2 border-gold pl-5">
                <p className="font-editorial text-lg italic leading-relaxed text-forest-deep">
                  “I wish I had done this a year earlier. One call replaced months of anxious Googling.”
                </p>
                <p className="mt-2.5 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                  — Mansoor A., MSc admit, Toronto
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="rounded-[2rem] border border-border bg-white p-7 shadow-[0_30px_80px_rgba(10,41,30,0.12)] sm:p-9">
              <IntakeForm source="lead_capture_section" idPrefix="inline-intake" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
